import React from 'react';
import {observer} from 'mobx-react';
import {Modal} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';
import LogoSpinner from 'shared/components/spinners/logo/LogoSpinner';
import {Button} from 'shared/components';

const Pending = observer(({name}) => {
  return (
    <div>
      <div className='waterloo pb2'>
        <FormattedMessage
          id="time_tracking.report_download.A download link for your report is being generated. Depending on the size and complexity of the report, this may take a few minutes. Please don't close this window."
          values={{reportName: <span className='dodger'>{name}</span>}}
        />
      </div>
      <div className='relative py4'>
        <LogoSpinner height='120' width='54' animate={true}/>
      </div>
    </div>
  );
});

const Failed = observer(({uiState}) => {
  return (
    <div>
      <div className='pb2'>
        <FormattedMessage id='time_tracking.report_download.An error occurred while generating your report. Please try again.'/>
      </div>
      <div className='center py2'>
        <Button onClick={() => uiState.requestDownload()}>
          <FormattedMessage id='time_tracking.report_download.Try again'/>
        </Button>
      </div>
    </div>
  );
});

const Ready = observer(({uiState}) => {
  const {reportDownload} = uiState;

  if (reportDownload.status === 'failed') {
    return (
      <Failed uiState={uiState}/>
    );
  }

  return (
    <div>
      <div className='waterloo pb2'>
        <FormattedMessage id='time_tracking.report_download.Your export is ready. Click the button below to download it.'/>
      </div>
      <div className='center py2'>
        <a className='Btn Btn--primary' href={reportDownload.link('reportFile')} onClick={() => uiState.closeModal()} download>
          <span className='Btn--content'>
            <FormattedMessage id='time_tracking.report_download.Download'/>
          </span>
        </a>
      </div>
    </div>
  );
});

const DownloadModal = observer(({uiState}) => {
  const {name, pending} = uiState;

  return (
    <Modal
      isOpen={uiState.modalOpen}
      onHide={() => uiState.closeModal()}
      closeButton={!uiState.pending}
      size='md'
    >
      <div className='h2 mb3'>
        <FormattedMessage
          id='time_tracking.report_download.EXPORT_REPORT'
          values={{reportName: name}}
        />
      </div>
      {pending ? <Pending name={name}/> : <Ready uiState={uiState}/>}
    </Modal>
  );
});

export default DownloadModal;
